import { z } from 'zod'

export const RentalInquirySubmitSchema = z.object({
	intent: z.literal('submit-inquiry'),
	listingId: z.string('Listing ID is required').min(1),
	firstName: z.string('First name is required').min(1),
	lastName: z.string().optional(),
	email: z.email('Valid email is required'),
	phone: z.string('Valid phone number is required').min(10),
	message: z.string().optional(),
})

export type RentalInquirySubmit = z.infer<typeof RentalInquirySubmitSchema>
